import AnimateCounter from '../components/animate-counter';
import elementIsVisibleInViewport from '../components/visible';

const ceCounter = () => {
  const counterElement = document.querySelectorAll('.ce_rsce_counter .number');

  counterElement.forEach((number) => {
    number.counterAlreadyFired = false;

    const interval = getComputedStyle(document.documentElement).getPropertyValue(number.parentElement.getAttribute('duration')) ? getComputedStyle(document.documentElement).getPropertyValue(number.parentElement.getAttribute('duration')) : 1000;

    let startValue = parseInt(number.parentElement.getAttribute('start'));
    const endValue = parseInt(number.parentElement.getAttribute('end'));
    let isCounted = false;

    number.doCount = () => {
      const animate = new AnimateCounter(number, startValue, endValue, interval).init();
    }
  });

  const handleScroll = () => {
    counterElement.forEach((number) => {
      if(true === number.counterAlreadyFired) return
      if(!elementIsVisibleInViewport(number)) return
      number.doCount();
      number.counterAlreadyFired = true;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
  });
}

export default ceCounter;
